export const CHANGE_NABVAR = 'CHANGE_NABVAR'

export const ChangeNavbar = (haveHeader) => {
	return {
		type: CHANGE_NABVAR,
		haveHeader
	}
}

export const SCROLL_TO_HEADER = 'SCROLL_TO_HEADER'
export const SCROLL_TO_ABOUT = 'SCROLL_TO_ABOUT'
export const SCROLL_TO_PARTNERS = 'SCROLL_TO_PARTNERS'
export const SCROLL_TO_SERVICES = 'SCROLL_TO_SERVICES'
export const SCROLL_TO_PROJECTS = 'SCROLL_TO_PROJECTS'
export const SCROLL_TO_GAMES = 'SCROLL_TO_GAMES'
export const SCROLL_TO_CONTACT = 'SCROLL_TO_CONTACT'

export const ScrollToHeader = (scrollToHeader) => {
	return {
		type: SCROLL_TO_HEADER,
		scrollToHeader
	}
}

export const ScrollToAbout = (scrollToAbout) => {
	return {
		type: SCROLL_TO_ABOUT,
		scrollToAbout
	}
}

export const ScrollToServices = (scrollToServices) => {
	return {
		type: SCROLL_TO_SERVICES,
		scrollToServices
	}
}

export const ScrollToProjects = (scrollToProjects) => {
	return {
		type: SCROLL_TO_PROJECTS,
		scrollToProjects
	}
}

export const ScrollToPartners = (scrollToPartners) => {
	return {
		type: SCROLL_TO_PARTNERS,
		scrollToPartners
	}
}

export const ScrollToGames = (scrollToGames) => {
	return {
		type: SCROLL_TO_GAMES,
		scrollToGames
	}
}

export const ScrollToContact = (scrollToContact) => {
	return {
		type: SCROLL_TO_CONTACT,
		scrollToContact
	}
}

export const SCROLL_TO = 'SCROLL'

export const ScrollTo = (scrollTo) => {
	return {
		type: SCROLL_TO,
		scrollTo
	}
}
